// extracted by mini-css-extract-plugin
export var bodyRow = "_ev-d";
export var cardColumns = "_ev-e";
export var ellipsesOverflow = "_ev-2";
export var flatBottomCorners = "_ev-3";
export var flatTopCorners = "_ev-4";
export var headerActionsDropdown = "_ev-f";
export var headerBottomRow = "_ev-c";
export var headerTopRow = "_ev-b";
export var orderDetailsWrapper = "_ev-0";
export var orderInfoContainer = "_ev-1";
export var productDetails = "_ev-9";
export var productImage = "_ev-5";
export var responsiveTable = "_ev-8";
export var shipmentContainer = "_ev-a";
export var tableBottomLeft = "_ev-6";
export var tableBottomRight = "_ev-7";
export var trackingLink = "_ev-g";